export const tradingCompetitionKeys = {
    tradingCompetition: (subdomain) => ['tradingCompetition', subdomain],
    allTradingCompetitions: (subdomain) => ['tradingCompetition', subdomain, 'all'],
    isUserRegistered: (subdomain, tradingCompetitionId) => ['tradingCompetition', subdomain, 'isUserRegistered', tradingCompetitionId],
    leaderboard: (subdomain, tradingCompetitionId, page, pageSize) => ['tradingCompetition', subdomain, 'leaderboard', tradingCompetitionId, page, pageSize],
    userTradingRank: (subdomain, tradingCompetitionId, userId) => ['tradingCompetition', subdomain, 'userRank', tradingCompetitionId, userId],
};
